"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileMenuHeader = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const context_1 = require("../../../styles/context");
const use_t_1 = require("use-t");
const BasicButtonBack_1 = require("../../../2-inline-block/BasicButton/BasicButtonBack");
const BasicButtonClose_1 = require("../../../2-inline-block/BasicButton/BasicButtonClose");
const styles_1 = require("./styles");
const MobileMenuHeader = ({ title, parent, onBack, onClose }) => {
    const [t] = (0, use_t_1.useT)();
    const styles = (0, context_1.useStyles)();
    const lineColor = styles.g(0.92);
    const fgColor = styles.g(0.15);
    const SLOT = 32;
    return (React.createElement("div", { className: (0, styles_1.headerClass)({
            bdb: `1px solid ${lineColor}`,
            col: fgColor,
        }) },
        React.createElement("div", { style: { width: SLOT, height: SLOT, flexShrink: 0, display: 'flex', alignItems: 'center' } }, parent && React.createElement(BasicButtonBack_1.BasicButtonBack, { onClick: onBack, title: t('Back') })),
        React.createElement("span", { className: (0, styles_1.headerTitleClass)({ col: fgColor }) }, title),
        React.createElement("div", { style: { width: SLOT, height: SLOT, flexShrink: 0, display: 'flex', alignItems: 'center' } },
            React.createElement(BasicButtonClose_1.BasicButtonClose, { onClick: onClose, title: t('Close') }))));
};
exports.MobileMenuHeader = MobileMenuHeader;
